import { Inject } from '@odinjs/odin';
import { ImageAPI, PanelAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { AuthenticationService, HistoryService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { AccountActivationAliases, FragmentNames } from '../../codegen';
import { FoundationRoute } from '../../constants';
import { AccountRoutesAPI } from '../../constants/account-routes';
import { ResponseError } from '../../interfaces';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.ACCOUNT_ACTIVATION })
export default class AccountActivationController extends BaseController {

  @Inject(AccountActivationAliases.PANEL_LOADER)
  panelLoader: PanelAPI;

  @Inject(AccountActivationAliases.PANEL_CONTENT)
  panelContent: PanelAPI;

  @Inject(AccountActivationAliases.TEXT_SUCCESS_TITLE)
  textSuccessTitle: TextAPI;

  @Inject(AccountActivationAliases.TEXT_SUCCCESS_SUBTITLE)
  textSuccessSubTitle: TextAPI;

  @Inject(AccountActivationAliases.TEXT_SUCCCESS_SUBTITLE_2)
  textSuccessSubTitle2: TextAPI;

  @Inject(AccountActivationAliases.IMAGE_SUCCESS)
  imageSuccess: ImageAPI;

  @OnMount({ target: AccountActivationAliases.LAYOUT_CONTENT })
  async onMountLayoutAccountActivation(): Promise<void> {
    try {
      const body = { token: '' };
      const currentRoute = HistoryService.getCurrentRoute();

      if (currentRoute === FoundationRoute.ACCOUNT_ACTIVATE) {
        // TODO
        const { token } = HistoryService.getCurrentRouteQueryParams();
        body.token = token as string;
        token && (await HttpService.post(AccountRoutesAPI.USER_ACCOUNT_ACTIVATION, { token }, {}));
      }

      if (!body.token) {
        this.redirectToLogin();
        return;
      }

      this.panelLoader.setVisible(false);
      this.panelContent.setVisible(true);
    } catch (error) {
      const { body } = error as Record<string, Value>;
      if (body) {
        const { expressionKey } = body as ResponseError;
        this.panelLoader.setVisible(false);
        this.panelContent.setVisible(true);
        this.imageSuccess.setVisible(false);
        this.textSuccessTitle.setValue(expressionKey);
        this.textSuccessSubTitle.setValue('');
        this.textSuccessSubTitle2.setValue('');
      }
    }
  }

  @OnClick({ target: AccountActivationAliases.BUTTON_GO_LOGIN })
  onClickButtonGoLogin(): void {
    this.redirectToLogin();
  }

  redirectToLogin(): void {
    if (window.location.pathname.includes('login')) return;

    AuthenticationService.redirectToLogin();
  }

}

